module.exports = __webpack_public_path__ + "static/img/bg-register.b274fd29.png";